window.addEventListener('DOMContentLoaded', function(e) {
    let sliders = document.querySelectorAll('.timeline.slider-element');
    for (let i = 0 ; i < sliders.length ; i++) {
        let prev = sliders[i].querySelector('button.prev');
        let next = sliders[i].querySelector('button.next');

        let track = sliders[i].querySelector('.slider-track');

        // Do some calculations
        let item_width = sliders[i].querySelector('.slider-track > *').getBoundingClientRect().width + 32;
        let num_in_view = Math.floor(window.innerWidth / item_width);
        let prev_end_position = sliders[i].getAttribute('data-num-items') - num_in_view;
        let end_position = sliders[i].getAttribute('data-num-items') - num_in_view;
        let max_translate = (item_width * end_position) - (window.innerWidth - (item_width * num_in_view)) + 32;

        sliders[i].setAttribute('style', `--tooltip-translate:${item_width}px; --tooltip-max-translate:${max_translate}px;`);

        prev.addEventListener('click', function(e) {
            let curr_pos = sliders[i].getAttribute('data-position');
            let target = parseInt(curr_pos) - 1;
            console.log(curr_pos, target);
            if (target >= 0) {
                sliders[i].setAttribute('data-position', target);
            }
            if (target == 0) {
                prev.classList.add('hidden');
            }
            next.classList.remove('hidden');
        })

        next.addEventListener('click', function(e) {
            let curr_pos = sliders[i].getAttribute('data-position');
            let target = parseInt(curr_pos) + 1;
            if (target <= end_position) {
                sliders[i].setAttribute('data-position', target);
            }
            if (target == end_position) {
                next.classList.add('hidden');
            }
            prev.classList.remove('hidden');
        })

        window.addEventListener('resize', function(e) {
            // Update calculations
            item_width = sliders[i].querySelector('.slider-track > *').getBoundingClientRect().width + 32;
            num_in_view = Math.floor(window.innerWidth / item_width);
            end_position = sliders[i].getAttribute('data-num-items') - num_in_view;
            max_translate = (item_width * end_position) - (window.innerWidth - (item_width * num_in_view)) + 32;

            if (prev_end_position != end_position) {
                if (sliders[i].getAttribute('data-position') == prev_end_position) {
                    sliders[i].setAttribute('data-position', end_position);
                }
                prev_end_position = end_position;
            }

            sliders[i].setAttribute('style', `--tooltip-translate:${item_width}px; --tooltip-max-translate:${max_translate}px;`);
        })


        // Touch handlers
        // let touchFlag = false;
        // let initX = null;
        // let preventFlag = false;
        // let totalMove = 0;
        // let trackStyle = window.getComputedStyle(track);
        // let initTrans = parseFloat(trackStyle.getPropertyValue('transform').split(',')[4]);
        // let offset;
        // let duration = track.style.getPropertyValue('transition-duration');

        // sliders[i].addEventListener('touchstart', function(e) {
        //     touchFlag = true;
        //     initX = e.touches[0].clientX;
        //     track.style.setProperty('transition-duration', '0s');
        //     initTrans = parseFloat(trackStyle.getPropertyValue('transform').split(',')[4]);
        // })
        // window.addEventListener('touchend', function(e) {
        //     touchFlag = false;
        //     track.style.setProperty('transition-duration', duration);
        //     track.style.setProperty('transform', '');

        //     // Do the stuff
        //     if (Math.abs(offset) >= 10) {
        //         preventFlag = true;
        //         let curr_pos = sliders[i].getAttribute('data-position');

        //         if (offset > 0) {
        //             let target = parseInt(curr_pos) - 1 - Math.floor(offset / item_width);
        //             if (target >= 0) {
        //                 sliders[i].setAttribute('data-position', target);
        //             }
        //             else {
        //                 target = 0;
        //                 sliders[i].setAttribute('data-position', target);
        //             }
        //         }
        //         else {
        //             let target = parseInt(curr_pos) + 1 + Math.floor(Math.abs(offset) / item_width);
        //             if (target <= end_position) {
        //                 sliders[i].setAttribute('data-position', target);
        //             }
        //             else {
        //                 target = end_position;
        //                 sliders[i].setAttribute('data-position', target);
        //             }
        //         }
        //     }

        //     setTimeout(() => {
        //         preventFlag = false;
        //     }, 100)
        // })
        // window.addEventListener('touchmove', function(e) {
        //     if (touchFlag) {
        //         offset = e.touches[0].clientX - initX;
        //         track.style.setProperty('transform', `translateX(${initTrans + offset}px)`);
        //     }
        // })

        // Click handlers
        // let clickFlag = false;

        // sliders[i].addEventListener('mousedown', function(e) {
        //     clickFlag = true;
        //     initX = e.clientX;
        //     offset = 0;
        //     track.style.setProperty('transition-duration', '0s');
        //     initTrans = parseFloat(trackStyle.getPropertyValue('transform').split(',')[4]);
        // })
        // window.addEventListener('mouseup', function(e) {
        //     clickFlag = false;
        //     track.style.setProperty('transition-duration', duration);
        //     track.style.setProperty('transform', '');

        //     // Do the stuff
        //     if (Math.abs(offset) >= 10) {
        //         preventFlag = true;
        //         let curr_pos = sliders[i].getAttribute('data-position');

        //         if (offset > 0) {
        //             let target = parseInt(curr_pos) - 1 - Math.floor(offset / item_width);

        //             if (target >= 0) {
        //                 sliders[i].setAttribute('data-position', target);
        //             }
        //             else {
        //                 target = 0;
        //                 sliders[i].setAttribute('data-position', target);
        //             }
        //         }
        //         else {
        //             let target = parseInt(curr_pos) + 1 + Math.floor(Math.abs(offset) / item_width);

        //             if (target <= end_position) {
        //                 sliders[i].setAttribute('data-position', target);
        //             }
        //             else {
        //                 target = end_position;
        //                 sliders[i].setAttribute('data-position', target);
        //             }
        //         }
        //     }

        //     setTimeout(() => {
        //         preventFlag = false;
        //     }, 100)
        // })
        // window.addEventListener('mousemove', function(e) {
        //     if (clickFlag) {
        //         offset = e.clientX - initX;
        //         track.style.setProperty('transform', `translateX(${initTrans + offset}px)`);
        //     }
        // })

        let anchors = sliders[i].querySelectorAll('a');
        if (anchors) {
            for (let j = 0 ; j < anchors.length ; j++) {
                anchors[j].addEventListener('click', function(e) {
                    if (!preventFlag) {
                        preventFlag = true; // reset flag
                        return;
                    }
                    e.preventDefault(); 
                })
            }
        }
    }
})